import React, { useState } from "react";
import {
  Building2,
  SlidersHorizontal,
  Users,
  FileStack,
  ShieldCheck,
  Server,
  ReceiptText
} from "lucide-react";
import UsuarioscuentasPage from './UsuarioscuentasPage';
import PreferenciasPage from './PreferenciasPage';
import AutorizacionesDianFirmaPage from './AutorizacionesDianFirmaPage';
import MiCuentaEditForm from './MiCuentaEditForm';
// IMPORTA aquí tus otros componentes de las otras pestañas

export default function ConfiguracionPage() {
  const [tabActiva, setTabActiva] = useState("micuentas");

  const tabs = [
    {id: "micuenta", label: "Mi Cuenta", icon: <Building2 className="w-4 h-4" /> },
    {  id: "preferencias", label: "Preferencias", icon: <SlidersHorizontal className="w-4 h-4" /> },
    { id: "usuarios", label: "Usuarios", icon: <Users className="w-4 h-4" /> },
    { id: "resoluciones", label: "Autorizaciones DIAN y Firma Digital", icon: <FileStack className="w-4 h-4" /> },
    { id: "facturacion", label: "Facturación", icon: <ReceiptText className="w-4 h-4" /> },
    
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-gray-50 to-white">
      <header className="sticky top-0 z-10 bg-white/95 border-b border-gray-200 shadow-sm px-8 py-2">
        <div className="flex flex-row items-center gap-2 mb-1">
          <Server className="h-6 w-6 text-blue-700 drop-shadow" />
          <span className="text-xl md:text-2xl font-bold tracking-tight text-blue-900">Parámetros </span>
        </div>
        <nav className="flex flex-row gap-0 mt-1">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setTabActiva(tab.id)}
              className={`flex items-center gap-2 px-3 py-1.5 rounded-t-lg text-[15px] font-medium border-b-2 transition-all duration-150
                ${tabActiva === tab.id
                  ? "border-blue-700 text-blue-800 bg-white"
                  : "border-transparent text-gray-500 bg-transparent hover:bg-blue-50 hover:text-blue-700"}
              `}
              style={{ minWidth: 130 }}
            >
              <span>{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </nav>
      </header>

      <main className="flex justify-center mt-8">
        <div className="w-full max-w-3xl bg-white shadow-xl rounded-2xl px-6 py-8 border border-gray-100 min-h-[420px]">
          {tabActiva === "cuenta" && <DatoscuentaPage />}
          {tabActiva === "preferencias" && <PreferenciasPage/>}
          {tabActiva === "usuarios" && <UsuarioscuentasPage />}
          {tabActiva === "resoluciones" && <AutorizacionesDianFirmaPage/>}
          {tabActiva === "firma" && <div>Firma Digital (en construcción)</div>}
          {tabActiva === "facturacion" && <div>Facturación (en construcción)</div>}
          {tabActiva === "micuenta" && <MiCuentaEditForm />}
        </div>
      </main>
    </div>
  );
}
